import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config/api';
import './LastPosts.css';

const RecentPosts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchRecentPosts();
    }, []);

    const fetchRecentPosts = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/posts/`);
            if (!response.ok) {
                throw new Error('Error al cargar los posts');
            }
            const data = await response.json();



            const recentPosts = data
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                .slice(0, 5);

            setPosts(recentPosts);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching recent posts:', error);
            setError('Error al cargar los posts recientes');
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="recent-posts-loading">
                <div className="loading-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="recent-posts-error">
                <p>{error}</p>
            </div>
        );
    }

    if (posts.length === 0) {
        return (
            <div className="recent-posts-empty">
                <p>No hay posts recientes</p>
            </div>
        );
    }

    return (
        <div className="recent-posts">
            <h3 className="recent-posts-title">Posts Recientes</h3>
            <div className="recent-posts-list">
                {posts.map((post, index) => (
                    <div key={post.id} className="recent-post-item">
                        <Link to={`/post/${post.slug}`} className="recent-post-link">

                            <span className="post-title">{post.title}</span>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentPosts;